import React from 'react';
import { Tooltip } from '@mui/material';
import Typography from '@mui/material/Typography';

export const SliderValueLabel = (props) => {
  const { children, open, value } = props;
  return (
    <Tooltip
      disableInteractive
      open={open}
      enterTouchDelay={0}
      placement="top"
      title={
        <React.Fragment>
          <Typography color="inherit">{value}</Typography>
        </React.Fragment>
      }
    >
      {children}
    </Tooltip>
  );
};
